document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('.article-template__content');
  if (!content) return;

  var headings = content.querySelectorAll('h2');
  if (headings.length < 2) return;

  var targetHeading = headings[Math.floor(headings.length / 2)];

  /* Blog tipini belirle */
  var isSeckin = window.location.pathname.indexOf('/blogs/seckin-yazilar') === 0;

  var cta = document.createElement('div');
  cta.className = 'eb-cta-mid';

  if (isSeckin) {
    /* Seçkin yazılar → kitaba yönlendir */
    cta.innerHTML = '<div class="eb-cta-mid__label">Erkek Benliği Arşivi</div>'
      + '<div class="eb-cta-mid__title">Bu konuyu uygulamaya dökmek istiyorsan:</div>'
      + '<div class="eb-cta-mid__desc">Psikoloji, maskülenite, sosyal dinamikler her birini derinlemesine ele alan 7 kitaplık müfredat. Okumak değil, dönüşmek için.</div>'
      + '<a href="https://erkekbenligi.com/products/seckin-erkegin-arsivi-7-kitapta-hukmetme-ustaligi" class="eb-cta-mid__btn">Arşive Bak →</a>';
  } else {
    /* Ücretsiz yazılar → Seçkin Yazılar'a yönlendir */
    cta.innerHTML = '<div class="eb-cta-mid__label">Seçkin Yazılar</div>'
      + '<div class="eb-cta-mid__title">Daha derine inmek istiyorsan:</div>'
      + '<div class="eb-cta-mid__desc">Google\'da bulamazsın. Sosyal medyada göremezsin. Sadece Seçkin Üyeler okuyabilir. Ayda 99 TL.</div>'
      + '<a href="/blogs/seckin-yazilar" class="eb-cta-mid__btn">Seçkin Yazılara Bak →</a>';
  }

  targetHeading.parentNode.insertBefore(cta, targetHeading);
});